<!-- 批量选型-末端风口 -->
<template>
  <div id="ProductList" class="page product-list">
    <div class="search-box">
      <!-- 筛选条件 -->
      <air-outlet-search ref="airOutletSearch" />
      <el-table
        v-if="tableData.length"
        :data="tableData"
        :row-style="{ height: '40px' }"
        :cell-style="cellStyle"
        :height="tableHeight"
        v-loading="isLoading"
      >
        <el-table-column prop="roomCode" label="房间编号">
          <template v-slot="{ row }">
            {{ row.roomCode || "- -" }}
          </template>
        </el-table-column>
        <el-table-column prop="roomName" label="房间名称">
          <template v-slot="{ row }">
            {{ row.roomName || "- -" }}
          </template>
        </el-table-column>
        <el-table-column prop="roomArea" label="房间面积 (㎡)">
          <template v-slot="{ row }">
            {{ row.roomArea || "- -" }}
          </template>
        </el-table-column>
        <el-table-column prop="roomArea" label="送风量 (㎡/h)">
          <template v-slot="{ row }">
            {{ row.airSupplyVolume || "- -" }}
          </template>
        </el-table-column>
        <el-table-column prop="calEquipmentNumber" label="计算数量">
          <template v-slot="{ row }">
            {{ row.calEquipmentNumber || "- -" }}
          </template>
        </el-table-column>
        <el-table-column
          label="指定数量"
          width="140px"
          align="center"
          prop="equipmentNumber"
        >
          <template slot-scope="scope">
            <el-input-number
              width="110px"
              :min="1"
              :precision="0"
              @change="numberChange(scope.row)"
              v-model="scope.row.equipmentNumber"
              placeholder="不指定"
            />
          </template>
        </el-table-column>
        <el-table-column prop="specification" label="规格">
          <template v-slot="{ row }">
            <span v-if="buttonIsShow">
              {{ row.specification || "- -" }}
            </span>
            <span v-if="!buttonIsShow && !row.productIds">
              {{ row.specification || "未找到合适规格" }}
            </span>
            <span v-if="!buttonIsShow && row.productIds">
              {{ row.specification }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          v-for="(item, index) in headerColumn"
          :key="index"
          :prop="item.prop"
          :label="item.value"
        >
          <template v-if="item.prop === 'nozzleThrow'" slot="header">
            <span style="padding-right: 8px">射程(m)</span>
            <el-tooltip
              class="item"
              effect="dark"
              content="根据产品性能数据估算"
              placement="top-start"
            >
              <i class="el-icon-question"> </i>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="144px">
          <template slot-scope="scope">
            <el-button
              @click="chooseDetail(scope.row, 'detail')"
              style="margin-right: 16px"
              type="text"
              size="small"
              :disabled="!scope.row.hasDetail"
              >查看详情</el-button>
            <el-button
              @click="chooseOthers(scope.row, 'others', scope.$index)"
              type="text"
              size="small"
              :disabled="buttonIsShow"
              >重新选择</el-button>
          </template>
        </el-table-column>
      </el-table>
      <empty-content v-else text="暂无房间信息" />
      <!-- 抽屉 -->
      <el-drawer
        close-on-click-modal
        :append-to-body="true"
        :modal="true"
        @open="handleOpen"
        :before-close="handleClose"
        :destroy-on-close="true"
        :direction="direction"
        :visible.sync="drawer"
        :size="drawerWidth"
        :custom-class="buttonType === 'detail'?'product-detail-drawer':''"
      >
        <template v-if="buttonType !== 'detail'" #title>
          <span>{{ currentRow.roomName }}</span>
        </template>
        <div>
          <fan-coil-detail v-if="buttonType === 'detail'" :productIds="productIds" />
          <air-outlet-others
            v-else
            :productRow="productRow"
            :currentRow="currentRow"
            :row-search="currentRowSearchData"
            @selectRow="getRow"
            ref="AirOutletOthers"
          />
        </div>
      </el-drawer>
      <!-- 一键选型 -->
      <div class="button-footer">
        <el-button class="lectotype" @click="chooseMsg">一键选型</el-button>
        <el-button
          class="confirm"
          @click="confirmAction()"
          :class="buttonIsShow ? 'active' : 'noActive'"
          :disabled="buttonIsShow">确认方案</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import FanCoilDetail from './FanCoilDetail.vue'
import AirOutletSearch from './components/batchSelection/AirOutletSearch.vue'
import AirOutletOthers from './AirOutletOthers.vue'
import {
  GetEquipmentBatchSelectionArguments,
  SetEquipmentBatchSelectionResults,
  GetGdcAccessToken,
} from '@/core/gcsUtils'
import EmptyContent from '@/components/business/EmptyContent'

export default {
  name: 'ProductList',
  components: {
    FanCoilDetail,
    AirOutletSearch,
    AirOutletOthers,
    EmptyContent,
  },
  data() {
    return {
      airOutletSearch: {},
      isFirstChoose: true,
      buttonIsShow: true,
      isLoading: false,
      buttonType: '',
      drawer: false,
      innerDrawer: false,
      direction: 'ltr',
      drawerWidth: '1120px',
      pageSize: 50,
      // 默认
      headerColumn: [],
      headerColumnInit: [
        { prop: 'length', value: '长度(mm)' },
        { prop: 'width', value: '宽度(mm)' },
        { prop: 'diameter', value: '直径(mm)' },
        { prop: 'nozzleThrow', value: '射程(m)' },
        { prop: 'outletVelocity', value: '出口风速(m/s)' },
      ],
      // 方形散流器、单层/双层百叶风口
      headerNotSpherical: [
        { prop: 'length', value: '长度(mm)' },
        { prop: 'width', value: '宽度(mm)' },
        { prop: 'outletVelocity', value: '出口风速(m/s)' },
      ],
      // 圆形散流器
      roundDiffuser: [
        { prop: 'diameter', value: '直径(mm)' },
        { prop: 'outletVelocity', value: '出口风速(m/s)' },
      ],
      // 球形喷口
      headerSpherical: [
        { prop: 'diameter', value: '直径(mm)' },
        { prop: 'nozzleThrow', value: '射程(m)' },
        { prop: 'outletVelocity', value: '出口风速(m/s)' },
      ],
      tableData: [],
      tableDataCopyChoose: [],
      productIds: '', // 产品ID
      productRow: [],
      currentRow: [],
      currentRowSearchData: {},
      currentValue: [],
      currentId: '', // 当前选择行ID
      selectVal: {},
      detailId: '',
      inputCondition: [],
      isChangeRow: false,
      currentIndex: '',
      tableDataReplace: [],
      confirmProductIds: [],
      resultData: [],
      paramsForMulti_room: {},
      isSelectStructures: false,
      // 品类编码
      gjwCategoryCode: 'C000012',
      // 品类名称
      gjwCategoryName: '末端风口',
      g_c_default_condition: true,
      g_c_selection_best_result: [],
      g_c_selection_alternative_result: [],
      // 结构形式传参
      paramsForProperties: {
        gjwCategoryCode: this.gjwCategoryCode,
      },
      // 是否为球形风口
      isSphericalDiffuser: false,
      isSingleLayer: false,
      // // 规格
      // specification: '',
      // // 长度
      // length: '',
      // // 宽度
      // width: '',
      // // 直径
      // diameter: '',
      // // 射程
      // nozzleThrow: '',
      // // 出口风速
      // outletVelocity: '',
      result: [],
      tableHeight: '',
      clickOrder: true,
    }
  },

  created() {
    // 获取机电数据
    this.getEquipmentBatchSelectionArguments()
    // 获取品牌
    this.loadBrands({
      gjwCategoryCode: this.gjwCategoryCode,
    })
  },

  mounted() {
    // 访问批量选型埋点
    this.$tracks({
      event: 'visitBachSelection',
      params: {
        g_c_class_code: this.gjwCategoryCode,
        g_c_class_name: this.gjwCategoryName,
      },
    })
    this.headerColumn = this.headerColumnInit
    this.tableHeight = document.body.clientHeight - 110
    // 窗口重置时候，重新获取高度
    window.onresize = () => {
      return (() => {
        this.tableHeight =
          document.body.clientHeight > 750
            ? document.body.clientHeight - 154
            : document.body.clientHeight - 110
      })()
    }
  },

  methods: {
    ...mapMutations({
      setProductId: 'productDetail/setProductId',
      setUserToken: 'user/setUserToken',
      setDetail: 'productDetail/setDetail',
      setPerformance: 'productDetail/setPerformance',
    }),

    ...mapActions({
      // 获取品牌
      loadBrands: 'list/loadBrands',
      // 获取筛选
      loadAggProperties: 'fanList/loadAggProperties',
      // 获取产品详情
      loadProperties: 'productDetail/loadProperties',
      loadDetail: 'productDetail/loadDetail',
      // 性能数据
      loadCurveData: 'productDetail/loadCurveData',
      loadRelatedComponents: 'productDetail/loadRelatedComponents',
      loadRelatedBlocks: 'productDetail/loadRelatedBlocks',
    }),

    // 获取机电数据
    async getEquipmentBatchSelectionArguments() {
      const projectInfoStr = await GetEquipmentBatchSelectionArguments()
      const { data: gToken } = await GetGdcAccessToken()
      this.setUserToken(gToken || null)
      // 获取机电传参
      this.inputCondition = projectInfoStr.data
      this.tableData = JSON.parse(JSON.stringify(this.inputCondition))
      // this.inputCondition = [
      //   {
      //     airSupplyVolume: 1400,
      //     roomArea: 250,
      //     roomCode: 'a1',
      //     roomId: '11',
      //     roomName: 'ABC1'
      //   },
      //   {
      //     airSupplyVolume: 1200,
      //     roomArea: 200,
      //     roomCode: 'a2',
      //     roomId: '12',
      //     roomName: 'ABC2'
      //   },
      //   {
      //     airSupplyVolume: 1000,
      //     roomArea: 150,
      //     roomCode: 'a3',
      //     roomId: '13',
      //     roomName: 'AB3C'
      //   },
      //   {
      //     airSupplyVolume: 800,
      //     roomArea: 100,
      //     roomCode: 'a4',
      //     roomId: '14',
      //     roomName: 'ABC4'
      //   },
      //   {
      //     airSupplyVolume: 500,
      //     roomArea: 50,
      //     roomCode: 'a5',
      //     roomId: '15',
      //     roomName: 'ABC5'
      //   },
      //   {
      //     airSupplyVolume: 4000,
      //     roomArea: 125,
      //     roomCode: 'a6',
      //     roomId: '16',
      //     roomName: 'ABC6'
      //   },
      //   {
      //     airSupplyVolume: 3000,
      //     roomArea: 125,
      //     roomCode: 'a7',
      //     roomId: '17',
      //     roomName: 'ABC7'
      //   }
      // ]
      // this.tableData = this.inputCondition
      this.tableData.forEach((v) => {
        v.nozzleThrow = '- -'
        v.length = '- -'
        v.width = '- -'
        v.diameter = '- -'
        v.outletVelocity = '- -'
      })
    },

    // 列表头换行
    renderHeader(h, { column, $index }) {
      const columnArr = column.label.split('||') // 此处换行标志
      if (columnArr.length >= 2) {
        const divArr = []
        columnArr.map((item) => {
          divArr.push(h('div', { style: 'text-align: center ' }, item))
        })
        return h('div', {}, divArr)
      }
      return h('div', {}, column.label)
    },

    // 设置行样式
    cellStyle({ row, column, rowIndex, columnIndex }) {
      let cellStyle
      if (!row.selectionParameter && !this.buttonIsShow && columnIndex > 4) {
        cellStyle = 'color: #E9AB39;'
      }
      return cellStyle
    },
    // 一键选型
    chooseMsg() {
      if (this.isFirstChoose) {
        this.isFirstChoose = false
        this.confirmChooseMsg()
      } else {
        this.$confirm('再次选型将覆盖已有数据，是否确认再次批量选型？', '确认提示', {
          type: 'warning',
          customClass: 'customClass',
        }).then(() => {
          this.confirmChooseMsg()
        }).catch(() => {})
      }
    },
    confirmChooseMsg() {
      this.isLoading = true
      const data = this.$refs.airOutletSearch.getSearchData()
      this.airOutletSearch = data.searchData
      this.isSphericalDiffuser = data.isSphericalDiffuser
      this.isSingleLayer = data.isSingleLayer
      this.g_c_default_condition = data.g_c_default_condition
      if (this.clickOrder) {
        this.tableData.forEach((v) => {
          v.nozzleThrow = '- -'
          v.specification = '- -'
          v.length = '- -'
          v.width = '- -'
          v.diameter = '- -'
          v.outletVelocity = '- -'
        })
      }
      this.clickOrder = false
      this.buttonIsShow = false
      // 根据风口类型展示对应列字段
      if (this.airOutletSearch.structuresName === '圆形散流器') {
        this.headerColumn = this.roundDiffuser
      } else if (this.airOutletSearch.structuresName === '球形喷口') {
        this.headerColumn = this.headerSpherical
      } else {
        this.headerColumn = this.headerNotSpherical
      }
      // 风口类型
      const productProperties = []
      productProperties.push(
        {
          code: 'P000205',
          parameterType: 'Enums',
          queryType: 'EQUAL',
          value: this.airOutletSearch.structuresCode,
        },
        {
          code: 'P000306',
          parameterType: 'Double',
          queryType: 'RANGE_TE',
          from: String(this.airOutletSearch.fromVelocity),
          to: String(this.airOutletSearch.toVelocity),
        }
      )

      if (this.isSphericalDiffuser) {
        // 喷口射程
        productProperties.push({
          code: 'P000209',
          parameterType: 'Double',
          queryType: 'EQUAL',
          value: this.airOutletSearch.nozzle_throw,
        })
      }

      this.paramsForMulti_room = {
        topSize: this.pageSize,
        brandCode: this.airOutletSearch.brandCode,
        inputCondition: this.inputCondition,
        productProperties: productProperties,
        singleUnitResponsibilityArea: Number(this.airOutletSearch.singleUnitResponsibilityArea),
      }
      if (this.isSingleLayer) {
        this.paramsForMulti_room = {
          topSize: this.pageSize,
          aspectRatioFrom: Number(this.airOutletSearch.aspectRatioFrom),
          aspectRatioTo: Number(this.airOutletSearch.aspectRatioTo),
          brandCode: this.airOutletSearch.brandCode,
          inputCondition: this.inputCondition,
          productProperties: productProperties,
          singleUnitResponsibilityArea: Number(this.airOutletSearch.singleUnitResponsibilityArea),
        }
      }
      this.$api.products.getMulti_room(this.gjwCategoryCode, this.paramsForMulti_room)
        .then((res) => {
          res = res || []
          const that = this
          that.tableDataReplace = []
          that.resultData = []
          that.isLoading = false
          // 获取合适型号ID集合
          that.confirmProductIds = []
          that.resultData = JSON.parse(JSON.stringify(res))
          that.tableDataReplace = res
          // 获取一键选型中返回的备选结果id列表
          that.g_c_selection_best_result = []
          that.g_c_selection_alternative_result = []
          res.forEach((v) => {
            if (v.id) {
              that.g_c_selection_best_result.push({
                roomId: v.roomId,
                productId: v.id,
              })
              that.g_c_selection_alternative_result.push({
                roomId: v.roomId,
                productId: v.productIds,
              })
            }
          })
          // 属性筛选：一键筛选参数（全局筛选条件）只包含筛选条件的内容，不包含机电穿过的
          delete that.paramsForMulti_room.inputCondition
          // 批量选型埋点
          this.$tracks({
            event: 'batchSelection',
            params: {
              g_c_class_code: this.gjwCategoryCode,
              g_c_class_name: this.gjwCategoryName,
              g_c_brand_code: that.airOutletSearch.brandCode,
              g_c_brand_name: that.airOutletSearch.brandName,
              // 选型初始条件： 机电传入数据
              g_c_selection_initial_condition: that.inputCondition,
              // 属性筛选：一键筛选参数（全局筛选条件）
              g_c_property: that.paramsForMulti_room,
              // 是否缺省条件：一键选型中增加全局筛选则为false
              g_c_default_condition: this.g_c_default_condition,
              // 最优选项结果：列表数据
              g_c_selection_best_result: that.g_c_selection_best_result,
              // 备选结果：一键选型中返回的备选结果id列表
              g_c_selection_alternative_result:
                that.g_c_selection_alternative_result,
              // 批量个数：房间的个数
              g_c_batch_numbers: that.inputCondition.length,
              // 批量成功个数：有最优选的房间的个数
              g_c_batch_success_numbers: that.g_c_selection_best_result.length,
            },
          })
          that.tableDataReplace.forEach((v) => {
            v.nozzleThrow = '- -'
            v.specification = '- -'
            v.length = '- -'
            v.width = '- -'
            v.diameter = '- -'
            v.outletVelocity = '- -'
            if (!v.selectionParameter) {
              return
            }
            v.selectionParameter.forEach((j) => {
              if (j.code === 'P000303') {
                v.specification = j.value
              }
              if (j.code === 'P000014') {
                v.length = j.value
              }
              if (j.code === 'P000015') {
                v.width = j.value
              }
              if (j.code === 'P000160') {
                v.diameter = j.value
              }
              if (j.code === 'P000209') {
                v.nozzleThrow = j.value
              }
              if (j.code === 'P000306') {
                v.outletVelocity = j.value
              }
            })
          })

          that.tableDataReplace.forEach((v) => {
            v.id && that.confirmProductIds.push(v.id)
          })
          const tableCopy = JSON.parse(JSON.stringify(that.inputCondition))
          tableCopy.forEach((v, index) => {
            that.tableDataReplace.forEach((j, index) => {
              if (v.roomId === j.roomId) {
                tableCopy[index] = {
                  ...tableCopy[index],
                  ...that.tableDataReplace[index],
                }
              }
            })
          })
          tableCopy.forEach((v, index) => {
            if (!v.selectionParameter) {
              v.specification = '未找到合适规格'
              this.isHasBestRoom = false
              v.hasDetail = false
            } else {
              // 仅球形喷口且有最有规格存在查看详情
              if (this.airOutletSearch.structuresName === '球形喷口') {
                v.hasDetail = true
              }
              this.isHasBestRoom = true
            }
          })

          tableCopy.forEach((v) => {
            // 优先展示指定设备台数
            if (!v.equipmentNumber) {
              v.equipmentNumber = undefined
            } else {
              v.calEquipmentNumber = '- -'
            }
          })
          // 一键选型时，将批量查询条件内置到每个房间
          tableCopy.forEach((item) => {
            item.searchData = { ...this.airOutletSearch }
          })
          that.tableData = tableCopy
        }).catch(() => {
          this.isLoading = false
          this.$msgbox(
            '存在不合理的输入值，请检查是否符合实际情况并重新输入。',
            '提示',
            {
              confirmButtonText: '确定',
              callback: (action) => {
                this.$message({
                  type: 'info',
                  message: `action: ${action}`,
                })
              },
            }
          )
        })
    },

    // 确认方案
    confirmAction() {
      const that = this
      that.result = []
      that.selectionParameter = []
      this.tableData.forEach((v) => {
        that.selectionParameter = []
        if (v.selectionParameter) {
          v.selectionParameter.forEach((v) => {
            if (v.name === '规格' || v.name === '出口风速') {
              that.selectionParameter.push(v)
            }
          })
        }
        that.result.push({
          roomId: v.roomId,
          productId: v.id,
          equipmentNumber: v.equipmentNumber || v.calEquipmentNumber,
          parameters: that.selectionParameter,
        })
      })
      const g_c_selection_best_result = []
      that.result.forEach((v) => {
        if (v.productId) {
          g_c_selection_best_result.push({
            roomId: v.roomId,
            productId: v.productId,
          })
        }
      })
      // 确认批量选型结果埋点
      this.$tracks({
        event: 'confirmBatchSelection',
        params: {
          g_c_class_code: this.gjwCategoryCode,
          g_c_class_name: this.gjwCategoryName,
          // 最优选项结果：列表数据
          g_c_selection_best_result: g_c_selection_best_result,
          // 批量个数：房间的个数
          g_c_batch_numbers: that.inputCondition.length,
          // 批量成功个数：有最优选的房间的个数
          g_c_batch_success_numbers: that.g_c_selection_best_result.length,
        },
      })
      SetEquipmentBatchSelectionResults(that.result)
    },

    // 抽屉弹出事件
    handleOpen() {
      if (this.buttonType === 'detail') {
        this.loadCurveData(this.productIds) // 基础选型不包含性能数据处理
        this.setProductId(this.productIds)
        this.loadProperties()
        this.loadDetail()
        this.loadRelatedComponents()
        this.loadRelatedBlocks()
      }
    },

    // 抽屉事件
    handleClose(done) {
      if (this.buttonType !== 'detail' && this.isChangeRow) {
        this.$confirm(
          '是否确认选择 ' + this.selectVal.specification + ' ?',
          '选择确认',
          {
            confirmButtonText: '确定',
            cancelButtonText: '放弃修改',
            type: 'warning',
            customClass: 'customClass',
          }
        )
          .then(() => {
            this.$message({
              message: '选型结果已更新',
              type: 'success',
            })
            this.changeRow()
            done()
          })
          .catch(() => {
            this.isChangeRow = false
            done()
          })
      } else {
        done()
      }
    },

    // 获取行数据
    getRow({ row, index }) {
      this.detailId = row.id
      this.isChangeRow = true
      this.selectVal = row
      this.selectIndex = index
    },

    // 修改行数据
    changeRow() {
      const index = this.currentIndex
      this.tableData[index].id = this.selectVal.id
      this.tableData[index].index = this.selectVal.index
      this.tableData[index].imageUrl = this.selectVal.imageUrl
      this.tableData[index].specification = this.selectVal.specification
      this.tableData[index].name = this.selectVal.name
      this.tableData[index].productSeriesId = this.selectVal.productSeriesId
      this.tableData[index].productSeriesName = this.selectVal.productSeriesName
      this.tableData[index].selectionParameter = this.selectVal.parameters
      this.tableData[index].diameter = this.selectVal.diameter
      this.tableData[index].length = this.selectVal.length
      this.tableData[index].nozzleThrow = this.selectVal.nozzleThrow
      this.tableData[index].outletVelocity = this.selectVal.outletVelocity
      this.tableData[index].width = this.selectVal.width
      this.tableData[index].searchData = this.selectVal.searchData
      this.tableData[index].productIds = this.selectVal.productIds
      if (this.selectVal.searchData && this.selectVal.searchData.structuresName === '球形喷口') {
        this.tableData[index].hasDetail = true
      }
    },

    // 查看详情
    async chooseDetail(v, type) {
      this.buttonType = type
      this.currentRow = v
      // 获取产品ID
      this.productIds = v.id
      this.drawer = true
      this.loadCurveData(this.productIds).then() // 基础选型不包含性能数据处理
      this.setProductId(this.productIds)
      this.loadProperties().then()
      this.loadDetail().then()
      this.loadRelatedComponents().then()
      this.loadRelatedBlocks().then()
      const projectInfo = await this.getProjectInfo()
      // 查看详情埋点
      this.$tracks({
        event: 'visitProductDetail',
        params: {
          g_c_class_code: this.gjwCategoryCode,
          g_c_class_name: this.gjwCategoryName,
          g_c_product_id: v.id,
          g_c_product_name: v.name,
          g_c_source: 'batchSelection',
          g_c_project_id: projectInfo.id,
          g_c_project_file_path: projectInfo.path,
          g_c_project_file_name: projectInfo.name
        },
      })
    },

    // 重新选择
    chooseOthers(row, type, index) {
      this.isChangeRow = false
      this.currentRow = row
      this.currentRowSearchData = { ...row.searchData }
      this.productRow = JSON.parse(JSON.stringify(row.productIds))
      this.currentId = row.id
      // 记录当前选取行
      this.currentIndex = index
      this.buttonType = type
      this.drawer = true
    },

    // 计算台数改变事件
    numberChange(v) {
      const changeRow = v
      this.inputCondition.forEach((v) => {
        if (v.roomId === changeRow.roomId) {
          v.equipmentNumber = changeRow.equipmentNumber
        }
      })
    },
  },
}
</script>

<style>
.customClass .el-icon-warning {
  color: #409eff !important;
}
</style>

<style lang="less" scoped>
.fixed-right-box {
  display: none;
}
.product-list {
  display: flex;
  flex-direction: column;
  padding-bottom: 10px;
  font-size: 12px;
  .search-box {
    flex: none;
  }
}
/deep/.search-box .el-table__header-wrapper {
  height: 50px !important;
}
/deep/.search-box .has-gutter tr {
  height: 50px !important;
}
/deep/.el-table__row {
  height: 40px !important;
}
/deep/.el-table th {
  padding: 0 !important;
}
/deep/.el-table td {
  padding: 0 !important;
}
/deep/.el-input-number--mini {
  width: 116px;
  line-height: 22px;
}
/deep/.el-button {
  margin-left: 0 !important;
}
/deep/.el-button--text {
  color: #4897f5;
}
/deep/.focus-message {
  color: red !important;
  background: blue !important;
}
/deep/.el-message--warning {
  background: blue !important;
}
.button-footer {
  text-align: right;
}
.button-footer .el-button {
  color: #fff;
  margin: 8px;
  width: 120px;
  height: 32px;
  border-radius: 2px;
}
.lectotype {
  color: #fff;
  background: #409eff;
}
.lectotype:focus {
  background: #409eff;
}
.confirm {
  color: #2dafcd !important;
}
.lectotype:hover {
  background: #409eff;
}
.active {
  color: #ccc !important;
  border-color: #ccc !important;
}
.noActive {
  color: #409eff !important;
  border-color: #409eff !important;
}
</style>
